import request from '@/utils/request'

export function queryHistoryExo(params) {
  return request({
    url: '/history/exo',
    method: 'post',
    data: params
  })
}

export function queryHistoryWave(params) {
  return request({
    url: '/history/wave',
    method: 'post',
    data: params
  })
}

export function queryHistoryWeather(params) {
  return request({
    url: '/history/weather',
    method: 'post',
    data: params
  })
}

export function queryHistoryWeatherRecord(params) {
  return request({
    url: '/history/weatherRecord',
    method: 'post',
    data: params
  })
}

export function queryHistoryWiz(params) {
  return request({
    url: '/history/wiz',
    method: 'post',
    data: params
  })
}

export function queryHistoryOil(params) {
  return request({
    url: '/history/oil',
    method: 'post',
    data: params
  })
}

export function queryHistoryFlow(params) {
  return request({
    url: '/history/flow',
    method: 'post',
    data: params
  })
}

export function queryHistoryFlowLayer3(params) {
  return request({
    url: '/history/flowLayer3',
    method: 'post',
    data: params
  })
}
